@if (goods && goods[0]) {
  <span class="d-inline-flex justify-content-between align-items-center w-100" [style.max-width.vw]="50">
    <span class="d-inline-block text-truncate align-self-end"
          [ngClass]="onClick ? 'cursor-pointer underline-tertiary link-underline-tertiary link-primary text-body' : ''"
          (click)="onClick ? onClick(goods[0]) : undefined">
      <app-highlight [term]="term"
                     [result]="goodsAsText(goods[0]) | middleEllipsis : ellipsisCharacterCount"></app-highlight>
    </span>
    @if (goods.length > 1) {
      <button onPopover data-bs-toggle="popover" [popoverContent]="goodsPopoverContent" placement="auto"
              popoverClass="pop-auto-container" class="btn btn-link link-dark p-0 ms-2">
        +{{ goods.length - 1 }}
      </button>
    }
  </span>
}


<ng-template #goodsPopoverContent>
  <div class="w-100 h-100 text-start p-1 pe-4" [style.max-width.px]="320">
    <div class="btn-close-wrapper rounded-circle position-absolute end-0 top-0 mt-2 me-2">
      <button type="button" class="btn-close" data-bs-toggle="popover" aria-label="Close"></button>
    </div>
    <div class="row gy-3">
      @for (goodsItem of goods; track goodsItem.goodsItemNumber) {
        <div class="col-12"
             [ngClass]="onClick ? 'cursor-pointer underline-tertiary link-underline-tertiary link-primary text-body' : ''"
             (click)="onClick ? onClick(goodsItem) : undefined">
          <div
            class="fw-bold">{{ goodsItem.commodity?.commodityCode?.harmonizedSystemSubHeadingCode }}{{ goodsItem.commodity?.commodityCode?.combinedNomenclatureCode || '' }}
          </div>
          <span>{{ goodsItem.commodity?.descriptionOfGoods | sentenceCase }}</span>
        </div>
      }
    </div>
  </div>
</ng-template>
